import { Props } from './interface'
import * as Styled from './styled'

function LargeRadio({ active, name, label, register, id }: Props) {
  const cellphoneRegexp = /(.{2}) (.{5}) (\d{4})/
  const cellphoneMask = '($1) $2-$3'

  return (
    <Styled.Wrapper>
      <Styled.Radio type="radio" name={name} register={register} value={id} />
      <Styled.Label htmlFor={label} $active={active}>
        {label?.replace?.(cellphoneRegexp, cellphoneMask)}
      </Styled.Label>
    </Styled.Wrapper>
  )
}

LargeRadio.defaultProps = { active: false }

export default LargeRadio
